var _excluded = ["show", "onShow", "title", "okText", "okButtonProps", "cancelText", "cancelButtonProps", "onOk", "onCancel", "className", "getPopper", "children", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { useAutoControlledBoolean, useCombineCallback, useRefCallback } from '@okee-uikit/react-hooks';
import { classnames } from '@okee-uikit/react-utils';
import { Content } from '../util/Content';
import { Button } from '../button';
import { Popover } from './Popover';
export function PopoverConfirm(props) {
  var show = props.show,
      onShow = props.onShow,
      title = props.title,
      okText = props.okText,
      okButtonProps = props.okButtonProps,
      cancelText = props.cancelText,
      cancelButtonProps = props.cancelButtonProps,
      onOk = props.onOk,
      onCancel = props.onCancel,
      className = props.className,
      getPopper = props.getPopper,
      children = props.children,
      icon = props.icon,
      extra = _objectWithoutProperties(props, _excluded);

  var onShowCallBack = useRefCallback(onShow);
  var onOkCallback = useRefCallback(onOk);
  var onCancelCallback = useRefCallback(onCancel);
  var localeOK = useLocale('popover.ok');
  var localeCancel = useLocale('popover.cancel');
  var cls = classnames(usePrefixCls('confirm'), className);
  var okCls = usePrefixCls('confirm-ok');
  var cancelCls = usePrefixCls('confirm-cancel');
  var footerCls = usePrefixCls('popover-confirm-footer');
  var controlled = typeof show !== 'undefined';

  var _useAutoControlledBoo = useAutoControlledBoolean({
    defaultValue: false,
    value: show,
    controlled: controlled
  }),
      _useAutoControlledBoo2 = _slicedToArray(_useAutoControlledBoo, 2),
      popperConfirmShow = _useAutoControlledBoo2[0],
      _useAutoControlledBoo3 = _useAutoControlledBoo2[1],
      setTrue = _useAutoControlledBoo3.setTrue,
      onHide = _useAutoControlledBoo3.setFalse;

  var onOkClickCallBack = useCombineCallback(onHide, onOkCallback);

  var renderOkBtn = function renderOkBtn() {
    var text = okText || localeOK;
    return React.createElement(Button, _objectSpread(_objectSpread({
      type: "primary",
      size: "xs"
    }, okButtonProps), {}, {
      className: okCls,
      onClick: onOkClickCallBack
    }), text);
  };

  var onCancelClickCallBack = useCombineCallback(onHide, onCancelCallback);

  var renderCancelBtn = function renderCancelBtn() {
    var text = cancelText || localeCancel;
    return React.createElement(Button, _objectSpread(_objectSpread({
      type: "default",
      size: "xs"
    }, cancelButtonProps), {}, {
      className: cancelCls,
      onClick: onCancelClickCallBack
    }), text);
  };

  var renderFooter = function renderFooter() {
    return React.createElement("div", {
      className: footerCls
    }, renderCancelBtn(), renderOkBtn());
  };

  var renderPopper = function renderPopper(data) {
    return React.createElement(Content, {
      prefixCls: "popover-confirm",
      header: title,
      footer: renderFooter,
      icon: icon
    }, typeof getPopper === 'function' ? getPopper(data) : getPopper);
  };

  var onPopoverShow = useCombineCallback(setTrue, onShowCallBack);
  return React.createElement(Popover, _objectSpread(_objectSpread({}, extra), {}, {
    show: popperConfirmShow,
    className: cls,
    getPopper: renderPopper,
    onHide: controlled ? onCancelCallback : onHide,
    onShow: onPopoverShow
  }), children);
}